import { type SVGAttributes } from "react";

export function DurationIcon({ ...props }: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.3062 11.6602C13.0045 11.7862 13.0045 12.2137 13.3062 12.3397C14.5116 12.8429 16.4589 13.8169 16.9284 15.0358L18.0765 18.0166C18.4705 19.0396 17.7154 20.1396 16.6192 20.1396H7.3811C6.28483 20.1396 5.52976 19.0396 5.92379 18.0166L7.07189 15.0358C7.54137 13.8169 9.48867 12.8429 10.694 12.3397C10.9958 12.2137 10.9958 11.7862 10.694 11.6602C9.48867 11.157 7.54137 10.183 7.07189 8.96405L5.92379 5.98328C5.52976 4.96027 6.28483 3.86029 7.3811 3.86029H16.6192C17.7154 3.86029 18.4705 4.96027 18.0765 5.98328L16.9284 8.96405C16.4589 10.183 14.5116 11.157 13.3062 11.6602Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}
